/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect } from 'react';
import moment from 'moment';
import Cookies from 'js-cookie';
import ReactLoading from 'react-loading';
import api from 'api';
import {
  Container,
  LoadingArea,
  ButtonArea,
  Printable,
  PrintStyles,
  Header,
  HrHeader,
  Footer,
  FooterRow,
  LogoIcon,
  Row,
  SectionContainer,
  SectionTitle,
  RowLabel,
  RowText,
  Column,
  SectionSmall,
  FooterText,
  ContainerBetween,
  ColumnBetween,
  RowBetween,
} from './styles';
import { formatCPF, formatCNPJ, formatPlate, formatPhone, formatZipCode, formatCurrency } from 'react-data-formatter';
import { loadingColor, white, logoDefault as myPassLogo } from 'styles/colorProvider';
import { Button, DocumentSupportChannels } from 'components';
import { MdChevronLeft } from 'react-icons/md';
import { BsPrinter } from 'react-icons/bs';
import { cpf } from 'cpf-cnpj-validator';
import { formatProposalStatus, PARTNER_77_ID } from 'utils/general';
import { getPremiumItemValue } from 'utils/premiumDisplay';

function PrintProposal({ location, history }) {
  const proposalId = parseInt(location.pathname.split('/')[2]);

  const [proposalData, setProposalData] = useState({});
  const [loading, setLoading] = useState(true);
  const [valueCoverage, setValueCoverage] = useState(0);
  const [valueService, setValueService] = useState(0);
  const [hasServices, setHasServices] = useState(false);
  const [hasCoverages, setHasCoverages] = useState(false);

  const loadData = async () => {
    const proposalNumber = {
      method: 'GET',
      url: `/proposal/${proposalId}`,
      headers: {
        'Content-Type': 'application/json',
        Authorization: Cookies.get('splitriskwl-authtoken'),
      },
      json: true,
    };
    setLoading(true);

    const response = await api(proposalNumber);

    let valueService = 0;
    let valueCoverage = 0;
    let hasCoverages = false;
    let hasServices = false;

    console.log('>> ', response.data?.arrayUnique);

    for (const item of response.data?.arrayUnique || []) {
      if (item.isService) {
        hasServices = true;
        valueService += Number(item.value);
      } else {
        hasCoverages = true;
        valueCoverage += Number(item.value);
      }
    }

    setProposalData(response.data);
    setHasCoverages(hasCoverages);
    setHasServices(hasServices);
    setLoading(false);
    setValueService(valueService);
    setValueCoverage(valueCoverage);
  };

  useEffect(() => loadData(), []);

  const isCpf = cpf.isValid(proposalData?.user?.cpf);
  const is77 = proposalData?.id_author_partner === PARTNER_77_ID;
  const premiumDisplay = proposalData?.premiumSummary || {
    netCoverage: (proposalData?.isHinova ? proposalData?.valueFinal : valueCoverage) - proposalData?.iof,
    iof: proposalData?.iof || 0,
    coverage: proposalData?.valueFinal - valueService,
    service: valueService,
    total: proposalData?.valueFinal || 0,
    isAnnual: false,
    installments: null,
    installmentValue: null,
  };
  return (
    <>
      <PrintStyles />
      {!loading && (
        <ButtonArea>
          <Button style={{ color: white }} height="30px" width="130px" onClick={() => window.print()}>
            <BsPrinter size="15" style={{ marginRight: 10 }} />
            Imprimir
          </Button>
        </ButtonArea>
      )}
      {loading && (
        <LoadingArea>
          <ReactLoading color={loadingColor} height={40} width={40} type="spin" />
        </LoadingArea>
      )}
      {!loading && (
        <Container>
          <Printable>
            <Header>
              <div className="titleArea">
                <h2>
                  Olá, <b>{proposalData?.user?.name?.toUpperCase()}</b>
                </h2>
                <h2>
                  Para você que está sempre em movimento,
                  <br />
                  aqui estão todos os detalhes do seu Seguro Auto.
                </h2>
              </div>
              <div className="logoArea">
                <img src={proposalData?.logo || ''} />
              </div>
            </Header>

            <HrHeader />

            <section>
              <ContainerBetween>
                <Column>
                  <RowBetween gap="6px" width="50%">
                    <b>Nº da proposta</b>
                    <p>{proposalData?.id}</p>
                  </RowBetween>

                  <RowBetween>
                    <RowLabel>Status da proposta:</RowLabel>
                    <RowText>{formatProposalStatus(proposalData?.status)}</RowText>
                  </RowBetween>

                  <RowBetween>
                    <RowLabel>Data de envio da proposta:</RowLabel>
                    <RowText>{proposalData?.created_at ? moment(proposalData?.created_at).format('DD/MM/YYYY') : '-'}</RowText>
                  </RowBetween>
                </Column>

                <Column>
                  <RowBetween>
                    <RowLabel>Protocolo:</RowLabel>
                    <RowText>{proposalData?.protocol}</RowText>
                  </RowBetween>
                </Column>
              </ContainerBetween>

              <SectionSmall>
                A Aceitação da proposta está sujeita a análise e aprovação do risco pela seguradora e o inicio de vigência somente
                ocorre após a aceitação do risco e do respectivo pagamento da parcela do seguro
              </SectionSmall>
              <SectionSmall>Esta proposta expira em 5 (cinco) dias caso não seja realizada a vistoria no veículo</SectionSmall>
              <SectionSmall>
                {premiumDisplay.isAnnual
                  ? 'Valores descritos nesta proposta referem-se ao período anual. Seguro na modalidade anual.'
                  : 'Valores descritos nesta propostas referem-se a mensalidade. Seguro na modalidade mensal recorrente.'}
              </SectionSmall>
            </section>

            <section>
              <SectionContainer>
                <SectionTitle>DADOS DO SEGURADO</SectionTitle>
              </SectionContainer>

              <ContainerBetween>
                <Column>
                  <RowBetween>
                    <b>Nome do segurado:</b>
                    <p>{proposalData?.user?.name?.toUpperCase()}</p>
                  </RowBetween>

                  <RowBetween>
                    <b>Data de nascimento:</b>
                    <p>{moment(proposalData?.user?.birthdate).utcOffset(0).format('DD/MM/YYYY')}</p>
                  </RowBetween>

                  <RowBetween>
                    <b>E-mail:</b>
                    <p>{proposalData?.user?.email}</p>
                  </RowBetween>

                  <RowBetween>
                    <RowLabel>Logradouro:</RowLabel>
                    <RowText>{proposalData?.address?.street}</RowText>
                  </RowBetween>

                  <RowBetween>
                    <b>Bairro:</b>
                    <p>{proposalData?.address?.district}</p>
                  </RowBetween>

                  <RowBetween gap="6px" width="25%">
                    <b>CEP:</b>
                    <p>{proposalData?.address?.zip_code}</p>
                  </RowBetween>
                </Column>

                <Column>
                  <RowBetween>
                    <b>CPF:</b>
                    <p>{formatCPF(proposalData?.maindriver_document || proposalData?.user?.cpf)}</p>
                  </RowBetween>

                  <RowBetween>
                    <b>Sexo:</b>
                    <p>{proposalData?.user?.gender === 1 ? 'Masculino' : 'Feminino'}</p>
                  </RowBetween>

                  <RowBetween>
                    <b>Telefone:</b>
                    <p>{formatPhone(proposalData?.user?.phone)}</p>
                  </RowBetween>

                  <RowBetween>
                    <b>Número:</b>
                    <p>{proposalData?.address?.number}</p>
                  </RowBetween>

                  <RowBetween>
                    <b>Cidade/UF:</b>
                    <p>
                      {proposalData?.address?.city} / {proposalData?.address?.state}
                    </p>
                  </RowBetween>
                </Column>
              </ContainerBetween>
            </section>
            <section>
              <SectionContainer>
                <SectionTitle>CONDUTOR PRINCIPAL</SectionTitle>
              </SectionContainer>

              <RowBetween>
                <RowLabel>Nome do condutor:</RowLabel>
                <RowText>{proposalData?.maindriver_name || proposalData?.user?.name}</RowText>
              </RowBetween>

              {proposalData?.proposalData?.maindriver_birthdate && (
                <RowBetween width="50%">
                  <RowLabel>Data de nascimento:</RowLabel>
                  <RowText>
                    {proposalData?.proposalData?.maindriver_birthdate
                      ? moment(proposalData?.proposalData?.maindriver_birthdate).utcOffset(0).format('DD/MM/YYYY')
                      : ''}
                  </RowText>
                </RowBetween>
              )}
            </section>

            <section>
              <SectionContainer>
                <SectionTitle>DADOS DO VEÍCULO</SectionTitle>
              </SectionContainer>

              <ContainerBetween>
                <Column>
                  <Row>
                    <RowLabel>Nome do condutor:</RowLabel>
                    <RowText>{proposalData?.maindriver_name || proposalData?.user?.name}</RowText>
                  </Row>
                  <Row>
                    <RowLabel>Marca:</RowLabel>
                    <RowText>{proposalData?.vehicle?.TB_CONSTANT_VEHICLE_BRANDS?.name}</RowText>
                  </Row>
                  <Row>
                    <RowLabel>Modelo:</RowLabel>
                    <RowText>{proposalData?.vehicle?.TB_CONSTANT_VEHICLE_MODELS?.name}</RowText>
                  </Row>
                  <Row>
                    <RowLabel>Cor:</RowLabel>
                    <RowText>{proposalData?.vehicle?.TB_CONSTANT_VEHICLE_COLOR?.name}</RowText>
                  </Row>
                  <Row>
                    <RowLabel>Placa:</RowLabel>
                    <RowText>
                      {proposalData?.vehicle?.plate === null ? 'Sem placa' : formatPlate(proposalData?.vehicle?.plate)}
                    </RowText>
                  </Row>
                  <Row>
                    <RowLabel>Ano fabricação/modelo:</RowLabel>
                    <RowText>
                      {proposalData?.vehicle?.manufacture_year}/{proposalData?.vehicle?.year_model}
                    </RowText>
                  </Row>
                  <Row>
                    <RowLabel>Chassi:</RowLabel>
                    <RowText>{proposalData?.vehicle?.chassi}</RowText>
                  </Row>
                  <Row>
                    <RowLabel>Valor*:</RowLabel>
                    <RowText>{proposalData?.vehicle?.value && formatCurrency(proposalData?.vehicle?.value)}</RowText>
                  </Row>
                  <Row>
                    <RowLabel>Código Fipe:</RowLabel>
                    <RowText>{proposalData?.vehicle?.TB_CONSTANT_VEHICLE_MODELS?.fipe_code}</RowText>
                  </Row>
                  <Row>
                    <RowLabel>Veículo de Leilão:</RowLabel>
                    <RowText>{proposalData?.vehicle?.auction || proposalData?.vehicle?.auction === 1 ? 'Sim' : 'Não'}</RowText>
                  </Row>
                  <SectionSmall>* Valor da Tabela Fipe do veículo na data da contratação</SectionSmall>
                </Column>
                <Column>
                  <Row>
                    <RowLabel>Uso do veículo:</RowLabel>
                    <RowText>{proposalData?.vehicle?.vehicle_use?.name || '--'}</RowText>
                  </Row>
                  <Row>
                    <RowLabel>Chassis Remarcado/Veiculo Recuperado de Sinistro:</RowLabel>
                    <RowText>{!!proposalData?.vehicle?.remarked ? 'Sim' : 'Não'}</RowText>
                  </Row>
                  <Row>
                    <RowLabel>0km:</RowLabel>
                    <RowText>{!!proposalData?.vehicle?.zero_km ? 'Sim' : 'Não'}</RowText>
                  </Row>
                  <Row>
                    <RowLabel>Possui GNV:</RowLabel>
                    <RowText>{!!proposalData?.vehicle?.gnv ? 'Sim' : 'Não'}</RowText>
                  </Row>
                  <Row>
                    <RowLabel>Região de Circulação:</RowLabel>
                    <RowText>
                      {proposalData?.address?.city} / {proposalData?.address?.state}
                    </RowText>
                  </Row>
                </Column>
              </ContainerBetween>
            </section>

            <section>
              <SectionContainer>
                <SectionTitle>DADOS DA PROPOSTA</SectionTitle>
              </SectionContainer>

              <Column>
                <RowBetween>
                  <RowLabel>Produto:</RowLabel>
                  <RowText>{proposalData?.findPartnerAssistance?.product_name}</RowText>
                </RowBetween>
                
                <RowBetween>
                  <RowLabel>Modalidade de Contratação:</RowLabel>
                  <RowText> VMR - Valor de Mercado Referenciado</RowText>
                </RowBetween>

                <RowBetween>
                  <RowLabel>Fator de Ajuste LMI: </RowLabel>
                  <RowText>
                    {proposalData?.policyData?.adjustment_factor || proposalData?.policyData?.adjustment || 100}%*
                  </RowText>
                </RowBetween>

                <RowBetween>
                  <RowLabel>LIMITE MÁXIMO DE INDENIZAÇÃO (LMI):</RowLabel>
                  <RowText>
                    Valor máximo a ser pago pela SEGURADORA, contratada para cada cobertura, escolhida pelo SEGURADO(A) e expresso
                    na proposta.
                  </RowText>
                </RowBetween>

                <RowBetween>
                  <RowLabel>PEÇAS E REPAROS:</RowLabel>
                  <RowText>
                    UTILIZAÇÃO DE PEÇAS (NOVAS, USADAS, ORIGINAIS OU NÃO), desde que mantenham a especificação técnica do
                    fabricante.
                  </RowText>
                </RowBetween>
              </Column>

              {hasCoverages && (
                <>
                  <SectionContainer>
                    <SectionTitle>COBERTURAS</SectionTitle>
                  </SectionContainer>

                  <table>
                    <thead>
                      <tr>
                        <td width={300}>Cobertura</td>
                        <td width={200}>LMI **</td>
                        <td width={150}>Prêmio</td>
                        <td width={250}>Franquias</td>
                      </tr>
                    </thead>
                    <tbody>
                      {proposalData?.arrayUnique
                        ? proposalData?.arrayUnique
                            .filter((item) => item.isService === false)
                            .map((product) => (
                              <tr>
                                <td>{product?.name}</td>
                                <td>{formatCurrency(product?.lmi || '--')}</td>
                                <td>{formatCurrency(getPremiumItemValue(product, premiumDisplay.isAnnual) ?? '--')}</td>
                                <td>{product?.deductible || '--'}</td>
                              </tr>
                            ))
                        : ''}
                    </tbody>
                  </table>
                </>
              )}

              {hasServices && (
                <>
                  <SectionContainer>
                    <SectionTitle>SERVIÇOS</SectionTitle>
                  </SectionContainer>
                  <table>
                    <thead>
                      <tr>
                        <td width={300}>Serviço</td>
                        <td width={200}>LMI **</td>
                        <td width={150}>Valor</td>
                        <td width={250}>Franquias</td>
                      </tr>
                    </thead>
                    <tbody>
                      {proposalData?.arrayUnique
                        ? proposalData?.arrayUnique
                            .filter((item) => item.isService === true)
                            .map((product) => (
                              <tr>
                                <td>{product?.name}</td>
                                <td>{formatCurrency(product?.lmi || '--')}</td>
                                <td>{formatCurrency(getPremiumItemValue(product, premiumDisplay.isAnnual) ?? '--')}</td>
                                <td>{product?.deductible || '--'}</td>
                              </tr>
                            ))
                        : ''}
                    </tbody>
                  </table>
                </>
              )}

              <SectionSmall>
                Em caso de indenização integral ou roubo e furto total, será aplicada a franquia regressiva estabelecida nas
                condições gerais da apolice.
              </SectionSmall>

              <br />

              {is77 && (
                <SectionSmall>
                  *IMPORTANTE: APÓS O PRIMEIRO EVENTO (SINISTRO), A FRANQUIA PARA SERVIÇOS A TERCEIROS SERÁ COBRADA DOBRADA (DUAS
                  VEZES O VALOR ORIGINAL) NOS DEMAIS EVENTOS RECLAMADOS NA APOLICE NO DECORRER DA VIGENCIA DO SEGURO.
                </SectionSmall>
              )}
              <SectionSmall>* Se selecionada a opção de leilão, o fator de ajuste deverá ser de 70%</SectionSmall>
              <SectionSmall>** Limite máximo de indenização</SectionSmall>
            </section>

            <section>
              <SectionContainer>
                <SectionTitle>VALOR DA PROPOSTA</SectionTitle>
              </SectionContainer>

              <Column>
                {hasCoverages && (
                  <RowBetween>
                    <RowLabel>Prêmio Líquido Coberturas:</RowLabel>
                    <RowText>{formatCurrency(premiumDisplay.netCoverage)}</RowText>
                  </RowBetween>
                )}

                <RowBetween>
                  <RowLabel>IOF:</RowLabel>
                  <RowText>{formatCurrency(premiumDisplay.iof)}</RowText>
                </RowBetween>

                {hasCoverages && (
                  <RowBetween>
                    <RowLabel>Prêmio Total Coberturas:</RowLabel>
                    <RowText>{formatCurrency(premiumDisplay.coverage)}</RowText>
                  </RowBetween>
                )}

                {hasServices && (
                  <RowBetween>
                    <RowLabel>Custo Serviços:</RowLabel>
                    <RowText> {formatCurrency(premiumDisplay.service)}</RowText>
                  </RowBetween>
                )}

                <RowBetween>
                  <RowLabel>Valor Total Seguro:</RowLabel>
                  <RowText>{formatCurrency(premiumDisplay.total)}</RowText>
                </RowBetween>

                {premiumDisplay.isAnnual && premiumDisplay.installments && premiumDisplay.installmentValue && (
                  <RowBetween>
                    <RowLabel>Parcelamento:</RowLabel>
                    <RowText>
                      {premiumDisplay.installments}x de {formatCurrency(premiumDisplay.installmentValue)}
                    </RowText>
                  </RowBetween>
                )}
              </Column>
            </section>

            <div class="page-break" />

            <section style={{ borderBottom: 'none' }}>
              <SectionContainer>
                <SectionTitle>RESUMO DAS COBERTURAS</SectionTitle>
              </SectionContainer>

              <DocumentSupportChannels partner={proposalData?.company} />

              <br />

              <h2>A íntegra das condições gerais deste produto, podem ser consultadas no portal www.splitrisk.com.br</h2>

              <h2>
                É fundamental que o segurado tenha conhecimento das cláusulas: 'Cláusula de riscos excluídos', ‘Perdas de
                Direitos', 'Obrigações do Segurado' e 'Cláusula de participação proporcional ou franquia', constantes nas
                condições gerais.
              </h2>

              {proposalData?.arrayUnique
                ? proposalData?.arrayUnique.map((product, index) => (
                    <>
                      {index === 3 && <div class="page-break" />}
                      <span className="generalConditionsTitle">{product?.name}</span>{' '}
                      <p style={{ textAlign: 'justify', marginBottom: 15, fontSize: 12 }}>{product?.description}</p>
                    </>
                  ))
                : ''}

              <>
                <span className="generalConditionsTitle">Valor determinado:</span>{' '}
                <p style={{ textAlign: 'justify', marginBottom: 15, fontSize: 12 }}>
                  É a modalidade de seguro, que garante ao Segurado, no caso de indenização integral, roubo ou furto do veículo, o
                  pagamento de quantia fixa, em moeda corrente nacional, conforme o LMI-Limite Máximo de Indenização e Fator de
                  Ajuste estabelecidos no ato da contratação e independentemente do valor de mercado do veículo quando da
                  ocorrência do sinistro.
                </p>
              </>

              <>
                <span className="generalConditionsTitle">Fator de ajuste:</span>{' '}
                <p style={{ textAlign: 'justify', marginBottom: 15, fontSize: 12 }}>
                  É o percentual estabelecido pela SEGURADORA ou seu corretor de seguros no ato da contratação do seguro, que será
                  aplicado sobre o valor que constar no LMI-Limite Máximo de Indenização de cotação para o veículo, para a
                  estipulação do valor da indenização integral do veículo segurado. A aplicação do fator de ajuste pode resultar
                  em valor inferior àquele valor do LMI-Limite Máximo de Indenização estabelecido na proposta, de acordo com as
                  características do veículo e seu estado de conservação.
                </p>
              </>
            </section>

            <section>
              <SectionSmall style={{ marginTop: 30 }}>
                Esse plano de seguro está registrado junto à SUSEP através do nº de processo {proposalData?.company?.process_number_susep}.{' '}
                As condições contratuais dos planos de seguro poderão ser consultadas no sítio eletrônico{' '}
                <a href="https://www.susep.gov.br" target="_blank" rel="noopener noreferrer">www.susep.gov.br</a>, a partir desse mesmo número.
              </SectionSmall>
            </section>
          </Printable>
        </Container>
      )}

      <Footer>
        <FooterRow>
          <FooterText>
            <p>
              Proposta emitida por: <b>{proposalData?.findPartnerAssistance?.social_reason}</b> | CNPJ:{' '}
              {proposalData?.findPartnerAssistance?.cnpj}{' '}
            </p>
          </FooterText>
          <LogoIcon>
            <img src={proposalData?.logo || ''} alt="Logo parceiro" />
          </LogoIcon>
        </FooterRow>
      </Footer>
    </>
  );
}

export default PrintProposal;
